export default __webpack_public_path__ + "7577d37d3734d289e8a3008fe20f69c0.svg";